import { jsx as e, jsxs as l } from "react/jsx-runtime";
import { useMemo as p, Fragment as m } from "react";
import r from "styled-components";
import { device as c } from "../../../utils/device.js";
import f from "./Button.js";
const x = r.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  margin-left: 4px;

  @media ${c.isMobile} {
    display: none;
  }
`, g = r.div`
  position: relative;
  padding-top: 2px;
  padding-left: 5.25px;
  padding-right: 5.25px;
`, j = ({ items: t }) => p(
  () => /* @__PURE__ */ e(x, { children: t.map((i, o) => {
    const n = o === t.length - 1, { text: a, link: d, enableLink: s } = i;
    return /* @__PURE__ */ l(m, { children: [
      /* @__PURE__ */ e(f, { text: a, link: d, isLastItem: n, enableLink: s }),
      !n && /* @__PURE__ */ e(g, { children: "/" })
    ] }, i.text);
  }) }),
  [t]
);
export {
  j as default
};
